import { useContext, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ProductContext } from "../context/ProductContext";

import { Helmet } from "react-helmet-async";
import BrandsMain from "../layouts/main/BrandsMain";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  height: 100vh;
`;
const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const Brands = () => {
  const { t, i18n } = useTranslation();
  const { loadProducts } = useContext(ProductContext);

  useEffect(() => {
    loadProducts();
  }, [i18n.language]);

  const seoData = {
    en: {
      title: "All Snus Brands & Nicotine Pouch Categories | SnusCo",
      description:
        "Browse all top nicotine pouch brands and categories at SnusCo. Discover a wide selection of flavors, strengths, and formats – shipped from Austria to all of Europe.",
      keywords:
        "snus brands, nicotine pouch categories, buy snus online, best nicotine brands, nicotine pouches Europe, snus Austria, SnusCo",
      ogTitle: "All Snus Brands & Nicotine Pouch Categories | SnusCo",
      ogDescription:
        "Explore our complete list of snus and nicotine pouch brands. From classic to modern, find your favorites and enjoy fast European delivery.",
      twitterTitle: "Top Snus Brands & Categories – Shop All | SnusCo",
      twitterDescription:
        "Discover all snus brands and nicotine pouch categories at SnusCo. Fast delivery across Europe from our Austrian base.",
      url: "https://www.snusco.eu/en/our-brands",
      image: "https://www.snusco.eu/images/brands-overview.jpg",
      locale: "en",
    },
    de: {
      title: "Alle Snus Marken & Nikotinbeutel Kategorien | SnusCo",
      description:
        "Entdecken Sie alle führenden Marken und Kategorien für Snus und Nikotinbeutel bei SnusCo. Große Auswahl an Geschmacksrichtungen, Stärken und Formaten – direkt aus Österreich, europaweit geliefert.",
      keywords:
        "Snus Marken, Nikotinbeutel Kategorien, Snus kaufen, Nikotinsäcke, SnusCo Österreich, Snus Markenübersicht, Snus Europa Versand",
      ogTitle: "Alle Snus Marken & Nikotinbeutel Kategorien | SnusCo",
      ogDescription:
        "Stöbern Sie durch unsere Markenübersicht für Snus und Nikotinbeutel. Entdecken Sie Top-Marken, starke Sorten und europaweiten Versand aus Österreich.",
      twitterTitle: "Top Snus Marken & Nikotinbeutel Kategorien | SnusCo",
      twitterDescription:
        "Alle führenden Marken für Snus & Nikotinbeutel im Überblick. Jetzt entdecken & europaweit mit SnusCo liefern lassen.",
      url: "https://www.snusco.eu/de/unsere-marken",
      image: "https://www.snusco.eu/images/brands-overview.jpg",
      locale: "de",
    },
  };

  const currentSeo = seoData[i18n.language] || seoData.en;

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>{currentSeo.title}</title>

        {/* Meta Description */}
        <meta name="description" content={currentSeo.description} />

        {/* Meta Keywords */}
        <meta name="keywords" content={currentSeo.keywords} />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={currentSeo.ogTitle} />
        <meta property="og:description" content={currentSeo.ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentSeo.url} />
        <meta property="og:image" content={currentSeo.image} />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={currentSeo.twitterTitle} />
        <meta
          name="twitter:description"
          content={currentSeo.twitterDescription}
        />
        <meta name="twitter:image" content={currentSeo.image} />

        {/* Canonical Link */}
        <link rel="canonical" href={currentSeo.url} />

        {/* Additional Meta Tags */}
        <meta property="og:locale" content={currentSeo.locale} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <BrandsMain />
    </>
  );
};

export default Brands;
